import { Component, Input } from '@angular/core';
import { Report } from '../../../models/report.model';
import { PExpandableTextComponent } from '../../../../shared/design-system/molecules/p-expandable-text/p-expandable-text.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-definitions-read-mode',
  standalone: true,
  imports: [PExpandableTextComponent, CommonModule],
  templateUrl: './definitions-read-mode.component.html',
  styleUrl: './definitions-read-mode.component.scss',
})
export class DefinitionsReadModeComponent {
  @Input() definitions!: Report.Definitions;
}
